import { useCallback, useState } from "react";
import { processError } from "../../../../common/utils/base_error";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import { useLocation, useParams } from "react-router";
import { GridRowSelectionModel } from "@mui/x-data-grid-pro";
import { useBackOrNavigate } from "../../../../common/utils/navigateUtils";
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { useReportViewer } from "../../../../config/hooks/utils/report_viewer";

import CommonConstants from "../../../../common/constants";
import { FuncionarioTreinamento } from "../../../rh/domain/models/funcionario_treinamento";
import { useGestaoTreinamentosCadastroFilters } from "../../../rh/presentation/hooks/GestaoTreinamentos_cadastro/filters";
import { useGestaoTreinamentosCadastroPagination } from "../../../rh/presentation/hooks/GestaoTreinamentos_cadastro/pagination";
import { RelatorioFuncionarioTreinamentoForm } from "../../../rh/presentation/schemas/Funcionarios_cadastro/relatorio_funcionario_treinamento_schema";
import { TreinamentoForm } from "../../../rh/presentation/schemas/Funcionarios_cadastro/treinamento_schema";
import { AvaliarTreinamentoForm } from "../../../rh/presentation/schemas/Funcionarios_cadastro/avaliar_treinamento_schema";
import { FuncionarioTercLista } from "../../domain/models/funcionarios_tercerizado_lista";
import { LogTipoTabela } from "../../../../common/utils/log_tabela_tipo";
import { useChangeHistory } from "../../../../common/hooks/use_change_history";

type LoadFuncionarioTercState = {
  IdFuncionarioTerc?:number,
};

export const useGestaoTreinamentosCadastroViewModel = () => {
  const {
    commons: {getAllLogAlteracaoUseCase, getAllLogAlteracaoByParentUseCase},
    reports: {
      getReportFuncionarioTreinamentoTercUseCase,
    },
    terceirizacao: {
      getFuncionarioTreinamentosUseCase,
      createFuncionarioTreinamentoUseCase,
      updateFuncionarioTreinamentoUseCase,
      deleteFuncionarioTreinamentoUseCase,
      avaliarTreinamentoUseCase,
      getAllListagemFuncionariosTercUseCase,
    },
    rh:{
      getFuncionarioAssinaturaDropDownUseCase,
      getTreinamentosDropDownUseCase,
    }
  } = useDependencyInjection();
  const { id } = useParams();

  const location = useLocation();

  const backOrNavigate = useBackOrNavigate();
  const changeHistory = useChangeHistory({
    getAllLogAlteracaoByParentUseCase: getAllLogAlteracaoByParentUseCase,
    getAllLogAlteracaoUseCase: getAllLogAlteracaoUseCase,
    onSetError: (e) => pushErrorNotification("Erro", [e]),
  });

  const { pushErrorNotification, pushInfoNotification } = usePageLoader();
  //#region Relatorio
    const [reportViewerState, startReportViewerProcess] = useReportViewer();
  //#endregion

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  const [openCadastroFuncionarioTreinamentoModal, setOpenCadastroFuncionarioTreinamentoModal] = useState(false);
  const [openAvaliarFuncionarioTreinamentoModal, setOpenAvaliarFuncionarioTreinamentoModal] = useState(false);
  const [openDeletarFuncionarioTreinamentoModal, setOpenDeletarFuncionarioTreinamentoModal] = useState(false);
  const [openDeletarFuncionarioTreinamentoLoteModal, setOpenDeletarFuncionarioTreinamentoLoteModal] = useState(false);
 

  const [funcionarioTreinamentos, setFuncionarioTreinamentos] = useState<FuncionarioTreinamento[]>();
  const [selectedFuncionarioTreinamento, setSelectedFuncionarioTreinamento] = useState<FuncionarioTreinamento>();
  const [idFuncionario, setIdFuncionario] = useState<number | undefined>(undefined);
    const [funcionario, setFuncionario] = useState<FuncionarioTercLista>();

  const [rowsSelectionModel, setRowsSelectionModel] = useState<GridRowSelectionModel>();
  const [selectedIdFuncionarioTreinamentosLote, setSelectedIdFuncionarioTreinamentosLote] = useState<number[]>();
  const [openDeletarFuncionarioTreinamentosLoteModal, setOpenDeletarFuncionarioTreinamentosLoteModal] = useState(false);

  const filters = useGestaoTreinamentosCadastroFilters();
  const pagination = useGestaoTreinamentosCadastroPagination();


 
   const loadFuncionarioTerc = useCallback(async (funcState?: LoadFuncionarioTercState) => {
      try {
        const filteredIdFuncionarioTerc = funcState?.IdFuncionarioTerc;
        await getAllListagemFuncionariosTercUseCase.getAllListagemFuncionarioTerc({IdFuncionarioTerc: filteredIdFuncionarioTerc},
          1,
          1,
        );
        const funcioanrioTerc = getAllListagemFuncionariosTercUseCase.items && getAllListagemFuncionariosTercUseCase.items.length > 0 ? getAllListagemFuncionariosTercUseCase.items[0] : null;

        if(funcioanrioTerc){
          setFuncionario(getAllListagemFuncionariosTercUseCase.items[0]);
      
        }
      } catch (e: unknown) {
        throw new Error("Falha ao buscar Funcionario Tercerizado!");
      }
  }, [getAllListagemFuncionariosTercUseCase]);

  const loadFuncionarioTreinamentos = useCallback(async (params?: { id?: number, page?: number, rowsPerPage?: number }) => {
    try {
      const id = params?.id ?? idFuncionario;

      if (id) {
        const page = params?.page ?? pagination.page;
        const rowsPerPage = params?.rowsPerPage ?? pagination.rowsPerPage;

        await getFuncionarioTreinamentosUseCase.getFuncionarioTreinamentos(
          id,
          page,
          rowsPerPage,
        );

        if (params && params.page !== undefined) pagination.setPage(params.page);
        if (params && params.rowsPerPage !== undefined) pagination.setRowsPerPage(params.rowsPerPage);

        setFuncionarioTreinamentos(getFuncionarioTreinamentosUseCase.items);

        pagination.setRowsPerPage(getFuncionarioTreinamentosUseCase.pageSize);
        pagination.setTotalItems(getFuncionarioTreinamentosUseCase.totalItems);
      }
    } catch (e: unknown) {
      setFuncionarioTreinamentos([]);
      throw e;
    }
  }, [
    idFuncionario,
    getFuncionarioTreinamentosUseCase,
    pagination
  ]);
  

  const loadTreinamentosDropDown = useCallback(async () => {
    try {
      setErrorMessage(undefined);
      const treinamentoLista = await getTreinamentosDropDownUseCase.getTreinamentosDropDown();
      useGestaoTreinamentosCadastroFilters.setState({ treinamentoLista });
    } catch (e: unknown) {
      useGestaoTreinamentosCadastroFilters.setState({ treinamentoLista: [] });
      throw e;
    }
  }, [getTreinamentosDropDownUseCase]);

  const loadFuncionarioAssinaturasDropDown = useCallback(async () => {
    try {
      const funcionarioAssinaturas = await getFuncionarioAssinaturaDropDownUseCase.getFuncionarioAssinaturaDropDown();
      useGestaoTreinamentosCadastroFilters.setState({ funcionarioAssinaturas });
    } catch (e: unknown) {
      useGestaoTreinamentosCadastroFilters.setState({ funcionarioAssinaturas: [] });
      throw e;
    }
  }, [getFuncionarioAssinaturaDropDownUseCase]);


  /**
   * useEffects
   */

  usePageStartBootstrap(async () => {
    try {
      if (!id) throw new Error("Id invalido!");

      setErrorMessage(undefined);
      setIdFuncionario(Number(id));

      await loadTreinamentosDropDown();
      await loadFuncionarioAssinaturasDropDown();
      await loadFuncionarioTreinamentos({ id: Number(id) });
      await loadFuncionarioTerc({ IdFuncionarioTerc: Number(id) });
    } catch (e: unknown) {
      setErrorMessage(processError(e, "Falha ao iniciar pagina!")[0]);
    }
  });
  const handleReloadPage = useCallback(async () => {
    try {
        setLoading(true);
        await loadTreinamentosDropDown();
        await loadFuncionarioAssinaturasDropDown();
        await loadFuncionarioTreinamentos();
      
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao carregar pagina!"));
    } finally {
      setLoading(false);
      setOpenAvaliarFuncionarioTreinamentoModal(false);
    }
  }, [loadTreinamentosDropDown, loadFuncionarioAssinaturasDropDown, loadFuncionarioTreinamentos, pushErrorNotification]);

  /**
   * Eventos
   */


  const handleBack = useCallback(() => {
    backOrNavigate('/GestaoTreinamentosTerceirizacao_lista');
  }, [ backOrNavigate]);
  
  const handlePageChange = useCallback(async (page: number) => {
    try {
      if (!saving && !loading) {
        setLoading(true);
        useGestaoTreinamentosCadastroPagination.getState().setPage(page + 1);
        await loadFuncionarioTreinamentos({ page: page + 1 });
      }
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao carregar pagina!"));
    } finally {
      setLoading(false);
      setOpenAvaliarFuncionarioTreinamentoModal(false);
    }
  }, [saving, loading, loadFuncionarioTreinamentos, pushErrorNotification]);
    
  const handleRowsPerPageChange = useCallback(async (rowsPerPage: number) => {
    try {
      if (!saving && !loading) {
        setLoading(true);
        useGestaoTreinamentosCadastroPagination.getState().setPage(1);
        useGestaoTreinamentosCadastroPagination.getState().setRowsPerPage(rowsPerPage);
        await loadFuncionarioTreinamentos({ page: 1, rowsPerPage });
      }
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao carregar pagina!"));
    } finally {
      setLoading(false);
      setOpenAvaliarFuncionarioTreinamentoModal(false);
    }
  }, [saving, loading, loadFuncionarioTreinamentos, pushErrorNotification]);
  

  const handleCadastroFuncionarioTreinamentoOpenState = useCallback((idFuncionarioTreinamento: number | null, openState: boolean) => {
      if (openState) {
        if (funcionarioTreinamentos && idFuncionarioTreinamento) {
          const treinamento = funcionarioTreinamentos.find((x) => x.idFuncionarioTreinamento === idFuncionarioTreinamento);
          setSelectedFuncionarioTreinamento(treinamento);
        } else {
          setSelectedFuncionarioTreinamento(undefined);
        }
      }
      setOpenCadastroFuncionarioTreinamentoModal(openState);
    }, [funcionarioTreinamentos]);

  const handleAvaliarFuncionarioTreinamentoOpenState = useCallback((idFuncionarioTreinamento: number | null, openState: boolean) => {
    if (openState) {
      if (funcionarioTreinamentos && idFuncionarioTreinamento) {
        const treinamento = funcionarioTreinamentos.find((x) => x.idFuncionarioTreinamento === idFuncionarioTreinamento);
        setSelectedFuncionarioTreinamento(treinamento);
        setSelectedIdFuncionarioTreinamentosLote(undefined);
      } else {
        setSelectedFuncionarioTreinamento(undefined);
      }
    }
    setOpenAvaliarFuncionarioTreinamentoModal(openState);
  }, [funcionarioTreinamentos]);

  const handleAvaliarLoteTreinamentoOpenState = useCallback((idFuncionarioTreinamentoLote: number[], openState: boolean) => {
    if (idFuncionarioTreinamentoLote) {
      setSelectedIdFuncionarioTreinamentosLote(idFuncionarioTreinamentoLote);
      setSelectedFuncionarioTreinamento(undefined);
    } else {
      setSelectedIdFuncionarioTreinamentosLote(undefined);
    }
    setOpenAvaliarFuncionarioTreinamentoModal(openState);
  }, []);

  const handleEditarFuncionarioTreinamento = useCallback((idFuncionarioTreinamento: number | null, openState: boolean) => {
    if (openState) {
      if (funcionarioTreinamentos && idFuncionarioTreinamento) {
        const treinamento = funcionarioTreinamentos.find((x) => x.idFuncionarioTreinamento === idFuncionarioTreinamento);
        setSelectedFuncionarioTreinamento(treinamento);
      } else {
        setSelectedFuncionarioTreinamento(undefined);
      }
    }
    setOpenCadastroFuncionarioTreinamentoModal(openState);
  }, [funcionarioTreinamentos]);
  
  const handleDeletarFuncionarioTreinamentoOpenState = useCallback((idFuncionarioTreinamento: number | null, openState: boolean) => {
    if (openState) {
      if (idFuncionarioTreinamento && funcionarioTreinamentos) {
        setSelectedFuncionarioTreinamento(funcionarioTreinamentos.find(x => x.idFuncionarioTreinamento === idFuncionarioTreinamento));
      } else {
        setSelectedFuncionarioTreinamento(undefined);
      }
    }
    setOpenDeletarFuncionarioTreinamentoModal(openState);
  }, [funcionarioTreinamentos]);
  
  const handleDeletarTreinamentosLoteOpenState = useCallback((idFuncionarioTreinamentosLote: number[], openState: boolean) => {
    setSelectedIdFuncionarioTreinamentosLote(idFuncionarioTreinamentosLote);
    setOpenDeletarFuncionarioTreinamentosLoteModal(openState);
  }, []);

  const handleSubmitTreinamento = useCallback(async (form: TreinamentoForm) => {
    try {
      if (!saving && !loading) {
        setSaving(true);
        if (funcionario) {
          if (!selectedFuncionarioTreinamento) {
            await createFuncionarioTreinamentoUseCase.createFuncionarioTreinamento(
              Number(funcionario.IdFuncionarioTerc),
              form.idTreinamento,
              form.cargaHoraria,
              form.local,
              form.instrutor,
              form.dataRealização,
              form.prazoAvaliacao,
            );
          } else {
            await updateFuncionarioTreinamentoUseCase.updateFuncionarioTreinamento(
              selectedFuncionarioTreinamento.idFuncionarioTreinamento,
              form.idTreinamento,
              form.cargaHoraria,
              form.local,
              form.instrutor,
              form.dataRealização,
              form.prazoAvaliacao,
            );
          }
          await loadFuncionarioTerc();
        }
      }
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao salvar documento!"));
    } finally {
      setSaving(false);
      setOpenCadastroFuncionarioTreinamentoModal(false);
    }
  }, [saving, loading, funcionario, selectedFuncionarioTreinamento, loadFuncionarioTerc, createFuncionarioTreinamentoUseCase, updateFuncionarioTreinamentoUseCase, pushErrorNotification]);
  
  const handleConfirmarDeletarFuncionarioTreinamento = useCallback(async () => {
    if (selectedFuncionarioTreinamento) {
      try {
        setSaving(true);
        await deleteFuncionarioTreinamentoUseCase.deleteFuncionarioTreinamento(
          selectedFuncionarioTreinamento.idFuncionarioTreinamento,
        );

        await loadFuncionarioTreinamentos();
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao deletar funcionario treinamento!"));
      } finally {
        setSaving(false);
        setSelectedFuncionarioTreinamento(undefined);
        setOpenDeletarFuncionarioTreinamentoModal(false);
      }
    }
  }, [deleteFuncionarioTreinamentoUseCase, loadFuncionarioTreinamentos, pushErrorNotification, selectedFuncionarioTreinamento]);


  const handleSubmitAvaliarTreinamento = useCallback(async (form: AvaliarTreinamentoForm) => {
    try {
      if (!saving && !loading) {
        setSaving(true);

        if (funcionarioTreinamentos) {
          if (selectedFuncionarioTreinamento) {
            await avaliarTreinamentoUseCase.avaliarTreinamento(
              selectedFuncionarioTreinamento.idFuncionarioTreinamento,
              form.eficaz,
              form.avaliador,
              form.dataAvaliacao,
              form.evidenciaObjetiva,
            );
          }
          else if (selectedIdFuncionarioTreinamentosLote) {
            await avaliarTreinamentoUseCase.avaliarTreinamentoLote(
              selectedIdFuncionarioTreinamentosLote,
              form.eficaz,
              form.avaliador,
              form.dataAvaliacao,
              form.evidenciaObjetiva,
            );
          }
          await loadFuncionarioTreinamentos();
        }
      }
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao salvar documento!"));
    } finally {
      setSaving(false);
      setOpenAvaliarFuncionarioTreinamentoModal(false);
    }
  }, [saving, loading, funcionarioTreinamentos, selectedFuncionarioTreinamento, selectedIdFuncionarioTreinamentosLote, loadFuncionarioTreinamentos, avaliarTreinamentoUseCase, pushErrorNotification]);


  //#region  relatorio
  const handleReportFuncionarioTreinamento= useCallback(async (idFuncionarioTreinamento: number) => {
    try {
      setLoading(true);

      await startReportViewerProcess({
        fetchCallback: async (requiredMimeType) =>
          await getReportFuncionarioTreinamentoTercUseCase.getReportFuncionarioTreinamentoTerc(requiredMimeType, idFuncionarioTreinamento),
      });

    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, 'Falha ao gerar relatorio de Funcionario Treinamento!'))
    } finally {
      setLoading(false);
    }
  }, [getReportFuncionarioTreinamentoTercUseCase, pushErrorNotification, startReportViewerProcess]);

  //#endregion

  const handleOpenChangeHistory = useCallback(
    (idTabela: number | null, tipoTabela: LogTipoTabela | null) => {
      if (idTabela && tipoTabela) {
        changeHistory.handleOpenChangeHistory(idTabela, tipoTabela, false);
      } else {
        if (idFuncionario) {
          changeHistory.handleOpenChangeHistory(idFuncionario, LogTipoTabela.FUNCIONARIO_TERC_TREINAMENTO, true);
        }
      }
    },
    [idFuncionario, changeHistory],
  );

  return {
    loading,
    saving,
    errorMessage,
    funcionarioTreinamentos: funcionarioTreinamentos ?? [],
    openCadastroFuncionarioTreinamentoModal,
    openAvaliarFuncionarioTreinamentoModal,
    openDeletarFuncionarioTreinamentoModal,
    openDeletarFuncionarioTreinamentoLoteModal,
    selectedFuncionarioTreinamento: selectedFuncionarioTreinamento ?? null,
    rowsSelectionModel,
    filters,
    pagination,
    reportViewerState,
    changeHistory,
    handleOpenChangeHistory,
    startReportViewerProcess,
    handleSubmitTreinamento,
    handleSubmitAvaliarTreinamento,
    handleReloadPage,
    handleBack,
    handleConfirmarDeletarFuncionarioTreinamento,
    handleAvaliarLoteTreinamentoOpenState,
    handleCadastroFuncionarioTreinamentoOpenState,
    handleAvaliarFuncionarioTreinamentoOpenState,
    handleEditarFuncionarioTreinamento,
    handleDeletarFuncionarioTreinamentoOpenState,
    handleDeletarTreinamentosLoteOpenState,
    handlePageChange,
    handleRowsPerPageChange,
    handleReportFuncionarioTreinamento


  };
}
